export default __webpack_public_path__ + "static/media/gallery_10.6ea3ecaf.jpg";